import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dtc-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss'],
  standalone: false,
})
export class PageContentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
